import { getTokenToLocalStorage } from '@/utils/token';
import { makeAutoObservable, action, toJS, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import userStore from './user';
interface Itabs {
  key: any;
  title: string;
  path: string;
  icon?: string;
  src?: string;
  platform?: string;
  isFinite?: boolean;
  content?: string;
  data?: any;
}
class Store {
  tabs: Itabs[] = [
    {
      key: 0,
      title: '首页',
      path: '/matrix',
      icon: '',
    },
    // {
    //   title: '今日头条',
    //   path: '/' + 'jrtt',
    //   key: '1',
    //   src: 'https://mp.toutiao.com/auth/page/login',
    //   icon: '',
    //   platform: '',
    //   isFinite: false,
    //   content: `<div id="1" style="height: 100%; display: block;"></div>`,
    // },
  ];
  loginLoading = false;
  logList = [];
  isClient = false;
  isLive = false;
  tabsActiveKey = 0;
  isShowDoc = false;
  configUrl = '';
  webviewKey = '';
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'clientTabs',
      properties: ['isClient'],
      storage: window.localStorage,
    });
  }
  @action addTab = (tab) => {
    console.log('action addTab------------------>', tab);
    const token = getTokenToLocalStorage();
    const auth = async () => {
      const isPathDuplicate = this.tabs.find(
        (t) => t.key == tab.key && t.title !== '账号授权'
      );
      console.log('isPathDuplicate---------', tab, isPathDuplicate);

      if (isPathDuplicate) {
        this.setActivePath(isPathDuplicate.key);
        this.webviewKey = isPathDuplicate.key;
        return;
      }

      const maxKey = tab.key
        ? tab.key
        : (this.tabs.length > 0
            ? Math.max(
                ...this.tabs
                  .filter((t) => typeof t.key === 'number')
                  .map((v) => v.key)
              )
            : 0) + 1;

      if (typeof tab.key !== 'number') {
        this.webviewKey = maxKey;
      }
      const newTab = { ...tab, key: maxKey, data: { ...tab.data } };
      console.log('newTab=======>', newTab);
      this.setActivePath(maxKey);
      this.tabs.push(newTab);

      setTimeout(async () => {
        // 延迟创建时仍使用本次授权页，避免切换标签后混用页面和账号参数。
        const activeTab = newTab;
        const container = document.getElementById(`${activeTab.key}`);
        if (!this.tabs.some((v) => v.key === activeTab.key) || !container) {
          return;
        }

        // 创建新的 webview 元素
        const webview = document.createElement('webview') as any;
        webview.src = activeTab?.src;
        webview.setAttribute('id', `webview-${activeTab?.key}`);
        webview.setAttribute('style', `width:100%;height:100%;`);
        webview.setAttribute('nodeintegration', 'false'); // 禁用 Node 集成
        // webview.setAttribute('disablewebsecurity', 'true'); // 禁用 Web 安全
        webview.setAttribute('allowpopups', 'true'); // 允许弹出窗口
        webview.setAttribute('partition', `persist:vidpost_${activeTab?.key}`); // 设置 partition
        // webview.setAttribute("useragent", navigator.userAgent);
        // webview.setAttribute(
        //   "useragent",
        //   "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36",
        // );
        webview.setAttribute(
          'useragent',
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36 Edg/135.0.0.0'
        );
        console.log('webview----', webview);

        // 监听 did-attach 事件，确保 WebView 已附加到 DOM
        webview.addEventListener('did-attach', () => {
          // 使用 setTimeout 延迟执行，确保 WebView 完全初始化
          setTimeout(async () => {
            if (!this.tabs.some((v) => v.key === activeTab.key)) return;
            try {
              const webviewId = webview.getWebContentsId();
              console.log('addwebviewId===================>', webviewId);

              if (activeTab.data?.cookie) {
                this.loginLoading = true;
              }
              // 调用 IPC 来处理网络监控等逻辑
              window.electron?.ipcRenderer.send(
                'webview-network-monitor',
                webviewId,
                activeTab.platform,
                activeTab?.key,
                activeTab.data,
                token
              );
              setTimeout(() => {
                this.loginLoading = false;
              }, 2000);
              console.log('trigger trylogin', tab.data);

              // if (tab.data?.cookie) {
              //   this.loginLoading = true;
              //   // 将新的 webview 元素添加到容器中
              //   await window.electron?.ipcRenderer.tryLogin({
              //     platform: activeTab.platform,
              //     webviewId: webview.getWebContentsId(),
              //     uuid: userStore.userInfo.uuid,
              //     authData: tab.data,
              //   });
              //   setTimeout(() => {
              //     this.loginLoading = false;
              //   }, 1000);
              // }
            } catch (error) {
              console.error('Error getting WebView contents ID:', error);
            }
          }, 100); // 延迟100毫秒，确保 WebView 完全准备好
        });

        console.log('activeTab?.key', activeTab?.key);

        container.appendChild(webview);
        // webview.addEventListener("dom-ready", () => {
        //   // webview.openDevTools();
        // });
      }, 300);
    };

    // auth();
    console.log(
      'token=================> ',
      window.electron.ipcRenderer.authDouyin,
      tab.platform
    );
    if (window.electron.ipcRenderer.authDouyin) {
      if (tab.platform != 12) {
        auth();
      } else {
        window.electron?.ipcRenderer.authDouyin({
          key: tab.key,
          auth_data: tab?.data,
          webToken: localStorage.getItem('Token'),
        });
      }
    } else {
      auth();
    }
  };
  @action updateTab = (tab) => {
    // const index = this.tabs.findIndex((v) => v.key === tab.key);
    this.tabs[0] = tab;
    this.setActivePath(tab.key);
  };
  @action setIsShowDoc = async (status) => {
    if (status) {
      this.configUrl =
        'https://cct3npbwsp.feishu.cn/docx/YU7UdzYL5o0rzlxh1IWcACVdn3e?from=from_copylink';
    }
    this.isShowDoc = status;
  };
  @action removeTab = (key) => {
    // 如果要删除的路径等于当前选中的路径
    const platform = this.tabs.find((tab) => tab.key === key)?.platform;
    console.log('platform------------', platform);

    if (this.tabsActiveKey == key) {
      const preIndex = this.tabs.findIndex((v) => v.key == key) - 1;
      if (preIndex < 0) return;
      this.setActivePath(this.tabs[preIndex].key);
    }
    this.tabs = this.tabs.filter(
      (tab) => tab.key !== this.tabs.find((v) => v.key == key).key
    );

    if (window.electron) {
      console.log(this.tabs, key);

      window.electron?.ipcRenderer.send('remove-webview', {
        platform,
        webviewId: key,
      });
    }
  };
  @action setActivePath = (key) => {
    this.tabsActiveKey = key;
  };
  @action updateIsClient = (val) => {
    this.isClient = val;
  };
  @action setIsLive = (val) => {
    this.isLive = val;
  };
  addLog(data: any) {
    if (this.logList.length > 10000) {
      this.logList.shift();
    }
    this.logList.push(data);
  }
}

const ClientTabs = new Store();
export default ClientTabs;
